import React, { useState, useEffect } from 'react';
import { GetPrevNextPost } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';

const AuthorBio = (postData) => {
  const [nextlink, setNextlink] = useState('');
  const [prevlink, setPrevlink] = useState('');
  const navigate = useNavigate();


  const blogData = postData.postData || {};

  return (
    <div class="profile-img">
      <img src={blogData.addedbyphoto} alt="Image" width={160} height={160} />

      <h3>{blogData.authorname}</h3>
      <p>{blogData.authorbio}</p>

      {/* <ul class="social-icon">
                                        <li class="share">
                                            Share
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i class="bx bxl-youtube"></i>
                                            </a>
                                        </li>
                                    </ul> */}
    </div>
  );
};

export default AuthorBio;